import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header className="w-full  shadow-sm">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between py-4 px-4 border-b">
        <Link href="/" className="font-bold text-xl">
          سداد قروض <span className="text-orange-500"> ابو سلمان</span>
        </Link>
      </div>

      <div className="border-b py-1 md:py-5">
        <nav className="flex flex-wrap gap-4 text-sm md:text-base mt-4 md:mt-0 justify-center">
          <Link href="/" className="text-orange-400 font-bold">
            الرئيسية
          </Link>
          <Link href="/">من نحن</Link>
          <Link href="/">تسديد قروض الطائف </Link>
          <Link href="/">سداد متعثرات الطائف </Link>
          <Link href="/">تسديد قروض الرياض</Link>
          <Link href="/">تمويل ٣٦ راتب</Link>
          <Link href="/">استخراج قرض جديد</Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
